import { useState, useRef, useEffect } from "react";

const CustomSelect = ({
    name,
    options = [],
    value,
    onChange,
    placeholder = "Select option",
}) => {
    const [open, setOpen] = useState(false);
    const containerRef = useRef(null);
    const [focusedIndex, setFocusedIndex] = useState(-1);

    // 🔹 Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // 🔹 Keyboard navigation
    const handleKeyDown = (e) => {
        if (!open && (e.key === "ArrowDown" || e.key === "Enter")) {
            setOpen(true);
            setFocusedIndex(0);
            return;
        }

        if (open) {
            if (e.key === "ArrowDown") {
                e.preventDefault();
                setFocusedIndex((prev) => (prev + 1) % options.length);
            } else if (e.key === "ArrowUp") {
                e.preventDefault();
                setFocusedIndex((prev) =>
                    prev === 0 ? options.length - 1 : prev - 1
                );
            } else if (e.key === "Enter" && focusedIndex >= 0) {
                e.preventDefault();
                onChange(name, options[focusedIndex]);
                setOpen(false);
            } else if (e.key === "Escape") {
                setOpen(false);
            }
        }
    };

    return (
        <div ref={containerRef} className="relative w-full">
            <button
                type="button"
                onClick={() => setOpen(!open)}
                onKeyDown={handleKeyDown}
                className={`capitalize w-full text-left text-gray-600 border border-gray-300 bg-white 
                    rounded-md px-3 py-1 focus:ring-1 focus:ring-gray-400
                     focus:border-gray-400 transition-colors ${open ? "ring-1 ring-gray-400 border-gray-400" : ""
                    }`}
            // className='focus:outline-1 outline-gray-300'
            >
                {value || placeholder}
            </button>

            {open && (
                <ul
                    role="listbox"
                    tabIndex={-1}
                    className="absolute mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg z-10 max-h-56 overflow-auto"
                >
                    {options.map((opt, index) => (
                        <li
                            key={opt}
                            role="option"
                            aria-selected={value === opt}
                            onClick={() => {
                                onChange(name, opt);
                                setOpen(false);
                            }}
                            onMouseEnter={() => setFocusedIndex(index)}
                            className={`capitalize px-3 py-2 cursor-pointer transition-colors 
                            ${value === opt
                                    ? "bg-gray-50 text-gray-600"
                                    : focusedIndex === index
                                        ? "bg-gray-100 text-gray-700"
                                        : "hover:bg-gray-100 hover:text-gray-700"
                                }`}
                        >
                            {opt}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default CustomSelect;
